import React, { useState, useEffect } from 'react';
import BoxWrapper from '../../../../components/ui/boxWrapper';
import axios from "../../../../axios-order";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem, Select, FormControl, InputLabel, Grid, FormHelperText } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
import Appbar from '../../../../components/appBar/appBar';

function ZohoTdsMapping() {
  const [mappingData, setMappingData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [zohoTdsName, setZohoTdsName] = useState('');
  const [cwsTdsName, setCwsTdsName] = useState('');
  const [zohoTdsNameError, setZohoTdsNameError] = useState('');
  const [cwsTdsNameError, setCwsTdsNameError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const getMappingData = () => {
    axios
      .get("/get_section_type_details")
      .then((res) => {
        setMappingData(res.data.records);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getMappingData();
  }, []);

  const tableBodyData = () => {
    if (mappingData && mappingData.length > 0) {
      return mappingData.map((item, i) => (
        <tr key={i}>
          <td>{item.tax_name}</td>
          <td>{item.cws_section}</td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={2}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };

  const handleClear = () => {
    setZohoTdsName('');
    setCwsTdsName('');
    setZohoTdsNameError('');
    setCwsTdsNameError('');
  };

  const handleDialogClose = () => {
    handleClear();
    setOpenDialog(false);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = () => {
    setZohoTdsNameError('');
    setCwsTdsNameError('');

    if (!zohoTdsName) setZohoTdsNameError('Please enter TAX Name');
    if (!cwsTdsName) setCwsTdsNameError('Please enter CWS Section Name');

    if (!zohoTdsName || !cwsTdsName) return;

    const payload = {
      records: [{ tax_name: zohoTdsName, cws_section: cwsTdsName }]
    };

    axios
      .post("/save_section_type", payload)
      .then((response) => {
        getMappingData();
        handleDialogClose();
        setSnackbarMessage(response.data.message);
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage('Something went wrong!');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      });
  };

  return (
    <>
     <Appbar />
      <div style={{ margin: "30px", marginTop: "80px" }}>
        <BoxWrapper
          boxTitle="Zoho TDS Mapping"
          enableAddButton={true}
          addButtonLabel="Add"
          addButtonHandlerFn={() => setOpenDialog(true)}
        >
          <div className="responsive-table-tds-threshold">
            <table className="custome-table">
              <tbody>
                <tr>
                  <th>TAX Name</th>
                  <th>CWS Section Name</th>
                </tr>
                {tableBodyData()}
              </tbody>
            </table>
          </div>
        </BoxWrapper>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        sx={{
          '& .MuiDialog-paper': {
            width: '500px',
            maxWidth: 'none',
            borderRadius: '10px',
            overflow: 'hidden',
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            padding: '16px 24px',
            backgroundColor: '#03406d',
            color: '#fff',
            fontSize: '15px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span>Add Zoho TDS Mapping</span>
          <span
            onClick={handleDialogClose}
            style={{ cursor: 'pointer', fontSize: '18px', color: '#fff', opacity: 0.7 }}
          >
            ✕
          </span>
        </DialogTitle>

        {/* Body */}
        <DialogContent sx={{ padding: '28px 24px 16px', backgroundColor: '#f9fbfd', paddingTop: '24px !important' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                Tax Name <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                placeholder="Enter TAX Name"
                value={zohoTdsName}
                onChange={(e) => setZohoTdsName(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                helperText={zohoTdsNameError}
                FormHelperTextProps={{ sx: { color: 'red', marginLeft: 0 } }}
                sx={{
                  backgroundColor: '#fff',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                    '&:hover fieldset': { borderColor: '#03406d' },
                    '&.Mui-focused fieldset': { borderColor: '#03406d' },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                CWS Section Name <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                placeholder="Enter CWS Section Name"
                value={cwsTdsName}
                onChange={(e) => setCwsTdsName(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                helperText={cwsTdsNameError}
                FormHelperTextProps={{ sx: { color: 'red', marginLeft: 0 } }}
                sx={{
                  backgroundColor: '#fff',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                    '&:hover fieldset': { borderColor: '#03406d' },
                    '&.Mui-focused fieldset': { borderColor: '#03406d' },
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            padding: '16px 24px',
            borderTop: '1px solid #e0e0e0',
            backgroundColor: '#f9fbfd',
            justifyContent: 'flex-end',
            gap: '10px',
          }}
        >
            <button className="button-primary" onClick={handleSubmit} type="submit">
            SUBMIT
            </button>
            <button
              type="button"
              className="button-outlined-secondary"
              onClick={handleDialogClose}
            >
            CANCEL
            </button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </>
  );
}

export default ZohoTdsMapping;